import React, { forwardRef } from "react";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";
import PopoverBtn from "../../popoverBtn";
import classNames from "classnames";
import FloatingLabel from "react-bootstrap/FloatingLabel";

const InputText = (props, ref) => {
  const {
    children,
    popoverText,
    error,
    valid,
    prefixIcon,
    className,
    fullWidth,
    multiInput,
    ...params
  } = props;
  const multiInputClass = fullWidth && multiInput ? "me-5" : "me-3";

  return (
    <>
      <Row
        className={classNames(
          "align-items-center flex-nowrap position-relative",
          {
            "mb-3": !className,
            [className]: className,
          }
        )}
      >
        <Col xs={12} md={!fullWidth && popoverText !== null ? 11 : 12}>
          <div className="position-relative">
            <FloatingLabel
              label={params?.placeholder}
              className={classNames("", {
                label_prefix: !!prefixIcon,
              })}
            >
              <Form.Control
                {...params}
                ref={ref}
                className={classNames("pe-5 pe-md-2", {
                  "border-danger": error,
                  "border-success": valid,
                  prefix: !!prefixIcon,
                })}
              />
            </FloatingLabel>
            {prefixIcon && (
              <div className="top-50 left-0 position-absolute translate-middle-y ms-3">
                {prefixIcon}
              </div>
            )}
          </div>
          {children}
        </Col>
        {popoverText !== null && (
          <div
            className={classNames(
              "position-absolute top-0 end-0 mt-3 w-auto",
              multiInputClass
            )}
          >
            <PopoverBtn text={popoverText} />
          </div>
        )}
      </Row>
    </>
  );
};

export default forwardRef(InputText);
